    import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import Pizzas from './pizzas';
import DrinksIt from './drinksIt';
import LunchSpecial from './lunchspecial';
import translateMenu from '../../helpers/translateMenu';
import BeerScreen from './beers';
import Panaderia from './panaderia'

const SHARED_CATEGORIES = ['postres', 'licor', 'coffe', 'drinks', 'bebidas'];

const stripLtPrefix = (name) =>
    (name || '').replace(/^LT\s*-\s*/i, '').trim();

function Index({ homeMode = 2 }) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showPizzas, setShowPizzas] = useState(false);
    const [showDrinksIt, setShowDrinksIt] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showBeers, setShowBeers] = useState(false);
    const [ShowPanaderia, setShowPanaderia] = useState(false);

   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };




         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
    
     const Item = ({ item }) => {
        const isSelected = dishs && dishs.id === item.id;

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 200,
                    height: 60,
                    position: 'relative',
                    cursor: 'pointer',
                    backgroundImage: `url(${require(
                        item.id === 943 ? './assets/botondorado.png' :
                            item.id === 944 ? './assets/botondorado.png'
:                             item.id === 960 ? './assets/botondorado.png' : './assets/BOTON1.png')})`,
                    backgroundPosition: 'center',
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    opacity: isSelected ? 1 : 0.95,
                }}
                onClick={() => {
                    if (item.id === 943) {
                        if (homeMode === 2) {
                            setShowDrinksIt(true)
                        } else {
                            setShowDrinks(true);
                        }
                        
                    } else if (item.id === 984) {
                        setShowPanaderia(true)
                    }
                    else if (item.id === 932) {
                            setShowPizzas(true)
                        } 
                    else if (item.id === 949) {
                        setShowBeers(true);
                    }
                    else {
                        setShowListProduct(true);
                        setdishs(item);
                    }
                }}
            >
                <p
                    style={{
                        color: item.id === 943 ? '#000' :
                            item.id === 944 ? '#000'
                            :  item.id === 960 ? '#000'
                            : '#fff',
                        fontSize: 20,
                        letterSpacing: 1,
                        textAlign: 'center',
                        fontFamily: 'Bebas_Neue',
                        textTransform: 'uppercase',
                        margin: 0,
                        maxWidth: '80%',
                        fontWeight: 'bold'
                    }}
                >
                   {stripLtPrefix(
                        langEng
                            ? item.name
                            : translateMenu(
                                  i18n.language,
                                  item.language,
                                  item.name,
                                  'name'
                              )
                    )}
                </p>
            </div>
        );
     };
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 725) {
                setdesserts(item);
            }
            if (item.id === 943) {
                setBeverages(item);
            }


            
        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
              if (homeMode === 2) {
                            setShowDrinksIt(true)
                        } else {
                            setShowDrinks(true);
                        }
        }} showBack={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{
                            position: 'absolute',
                            left:22,top: 27,
                            background: 'black', padding: 5, display: "flex", gap: 10, borderRadius: 14
                        }}>
                            <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/instagram.png')}
                            />
                            <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/facebook.png')}
                        />
                        </div>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 300,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 30
                                
                            
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        
                       
                    </div>

                     <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <img
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require(homeMode === 2 ? './assets/bannerh.png' : './assets/bannerlat.png')}
                            style={{
                        marginTop: -20,
                        width: '100%',
                        height: 195,
                        objectFit: 'contain',
                        borderRadius: 15,
                         pointerEvents: 'none',
                        
                    }}
                    />
                  
                    </div>
                    
                    <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignContent: 'flex-start',
                                rowGap: homeMode == 2 ? 10: 28,
                                columnGap: 40,
                                height:  homeMode == 2 ? 360: 250,
                                overflowY: 'auto',
                                paddingRight: 0,
                                boxSizing: 'border-box',
                                marginTop: homeMode == 2 ? 10: 10,
                                alignItems: 'flex-start',
                            }}
                        >
                            
                                {menus.map((item, key) => {
                                if ([940, 768, 726, 769, 770, 927, 961].includes(item.id)) return null;
                                const isLT = item.name.startsWith('LT');
                                const isShared = SHARED_CATEGORIES.includes(item.name.toLowerCase().trim());
                                if (homeMode === 1 && !isLT && !isShared) return null;
                                if (homeMode === 2 && isLT) return null;
                                return <Item item={item} key={key} />;
                            })}
                           
                    </div>
                    
                    {homeMode == 2 && 
                    
                     <div>
                                <img
                           
                            src={require( './assets/bannerit.png')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 180,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                            }}
                            />
                             </div>
                    }
                    
                    {homeMode === 1 &&  <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 20,
                        boxSizing: 'border-box',
                        gap: 10,
                       
                    }}>
                    <div style={{ width: '100%', marginTop: 20}}>
                            <div>
                                <img
                           
                            src={require( './assets/bannerlats.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 260,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                            }}
                            />
                          
                             
                            </div>

                    </div>
                    </div>}
                   
               
            </div>

           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                homeMode={homeMode}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showBeers && <BeerScreen setShowHappy={setShowBeers} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                {showPizzas && <Pizzas setShowHappy={setShowPizzas} />}
                 {ShowPanaderia && <Panaderia setShowHappy={setShowPanaderia} />}
                {showDrinksIt && <DrinksIt setShowHappy={setShowDrinksIt} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                    homeMode={homeMode}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;